import React from 'react';
import { Color } from '../../../themes/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import theme from '../../../themes/CBB/theme';

const useStyles = makeStyles((theme: any) => ({
  divider: {
    overflow: 'hidden',
    width: 1,
  },
}));

export default function DividerVertical({
  height = '100%',
  marginTop = 0,
  marginBottom = 0,
  color = Color.GREEN_DEEP,
}) {
  const classes = useStyles();

  return (
    <div
      className={classes.divider}
      style={{
        height,
        marginTop: theme.spacing(marginTop),
        marginBottom: theme.spacing(marginBottom),
        backgroundColor: theme.palette['brand'][color],
      }}
    />
  );
}
